import i18n, { type InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";

export const setupI18n = ({ options }: { options?: InitOptions }) => {
  i18n.use(initReactI18next).init({
    ...options,
    fallbackLng: "pl",
    debug: false,
    interpolation: { escapeValue: false, prefix: "%{", suffix: "}" },
  });

  return i18n;
};
